import { Stack, StackProps } from "@mui/material";
import { FC } from "react";
import { useHeaderHeight } from "../hooks/useHeaderHeight";

export const FullHeightStack: FC<StackProps> = (props) => {
  const headerHeight = useHeaderHeight();
  const height = `calc(100% - ${headerHeight}px)`;
  return <Stack {...props} sx={{ height, ...props.sx }} />;
};
